import { render } from "./PedidoEmAndamento.vue?vue&type=template&id=0740458c&scoped=true"
import script from "./PedidoEmAndamento.vue?vue&type=script&lang=js"
export * from "./PedidoEmAndamento.vue?vue&type=script&lang=js"

import "./PedidoEmAndamento.vue?vue&type=style&index=0&id=0740458c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.goncalves\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0740458c"]])

export default __exports__